import axios, { AxiosResponse } from 'axios';
import { apiClient } from '../apiClient';

export interface Entity {
    _id: string;
    designation: string;
    crudStatus: number;
    address: string;
    longitude?: number;
    latitude?: number;
    phoneNumber?: string;
    usageCount?: {
        total: number;
        sites: number;
    };
    updatedAt?: string;
    createdAt?: string;
}

export interface EntitiesResponse {
    message: string;
    data: Entity[];
}

export interface GetEntitiesQueries {
    active?: boolean;
    withUsage?: boolean;
}

export const getAllEntities = async (queries?: GetEntitiesQueries): Promise<EntitiesResponse> => {
    try {
        const response: AxiosResponse<EntitiesResponse> = await apiClient.get('/entities', { params: queries });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export interface UpdateEntityBody {
    designation?: string;
    crudStatus?: number;
    address?: string;
    longitude?: number | null;
    latitude?: number | null;
    phoneNumber?: string | null;
}

export interface EntityResponse {
    message: string;
    data: Entity;
}

export const updateEntity = async (loadNatureId: string, data: UpdateEntityBody): Promise<EntityResponse> => {
    try {
        const response: AxiosResponse<EntityResponse> = await apiClient.patch('/entities/' + loadNatureId, data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export interface CreateEntityBody {
    designation: string;
    address: string;
    crudStatus?: number;
    longitude?: number | null;
    latitude?: number | null;
    phoneNumber?: string | null;
}

export const createEntity = async (data: CreateEntityBody): Promise<EntityResponse> => {
    try {
        const response: AxiosResponse<EntityResponse> = await apiClient.post('/entities', data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};
